/*
 * @Author: liyxt
 * @Date: 2020-05-19 15:47:39
 * @LastEditors: bbqin
 * @LastEditTime: 2022-03-26 13:49:07
 * @Description: file content
 */
/**
 * Created by wangshhj on 2018/1/10.
 */
import React, { Component } from 'react';
//import OriginRadio from 'bee-radio';
import { Radio as OriginRadio } from '@tinper/next-ui'
import { getSysFieldid } from '@platform/api';

require('./index.less');

const { Group: OriginRadioGroup, Button: OriginRadioButton } = OriginRadio;

class RadioGroup extends Component {
    // 兼容老参数 左侧老参数 右侧新参数
    mapAntdPropsToNcProps = () => {
        let newProps = { ...this.props };
        //antd Modal参数与NCModal参数的映射
        const mapProps = {
            selectedValue: "value", 
        };
        for (const [antdProps, ncProps] of Object.entries(mapProps)) {
            if (antdProps in this.props) {
                newProps[ncProps] = this.props[antdProps];
            }
            if (antdProps !== "className") {
                delete newProps[antdProps];
            }
        }
        return newProps;
    };
    render() {
        let mapProps = this.mapAntdPropsToNcProps();
        return <div
            className={`radio-group-hotkey-wrapper`}
            onKeyDown={(e) => {
                if ([e.keyCode, e.which, e.charCode].find((e) => e === 13) || e.key === "Enter") {
                    this.props.onEnter && this.props.onEnter({ e: e });
                }
            }}
        >
            <OriginRadioGroup {...mapProps}>{this.props.children}</OriginRadioGroup>
        </div>;
    }
}
class RadioButton extends Component {
    render() {
        // 居然不支持 className
        return <OriginRadioButton {...this.props} className={`${this.props.className} nc-radio`}>{this.props.children}</OriginRadioButton>;
    }
}

class Radio extends Component {
    render() {
        let {
            fieldid,
            className = '',
            ...others
        } = this.props;


        if (!fieldid) {
            fieldid = null;
            if (this.props.children) {
                if (typeof this.props.children === "string") {
                    fieldid = this.props.children;
                } else if (this.props.children instanceof Array) {
                    fieldid = this.props.children[0];
                }
            }
        }

        fieldid = getSysFieldid(fieldid);

        return <OriginRadio
            {...others}
            fieldid={fieldid ? `${fieldid}_radio` : null}
            className={className + ' base-radio '}
        >
            {this.props.children}
        </OriginRadio>;
    }
}
export default Radio;

Radio.RadioGroup = RadioGroup;
Radio.RadioButton = RadioButton;
Radio.Button = RadioButton;
Radio.Group = RadioGroup;
